module.exports = {
    en: {
        sale: {
            team: 'Sales team',
        }

    },
    ka: {
        sale: {
            team: 'გაყიდვების გუნდი',
        }
    },
    ru: {
        sale: {
            team: 'отдел продаж'
        }
    }
}